module.exports = __webpack_public_path__ + "static/media/gradient-endY-icon.03a87067.svg";